<template>
  <v-navigation-drawer
    @input="changeDrawerFlag"
    :value="openFlag"
    width="220"
    fixed
    clipped
    app
  >
    <slot></slot>
  </v-navigation-drawer>
</template>

<script>
import {
  getters as drawerGetters,
  actions as drawerActions,
} from '@/vuex/modules/ui/drawer/constants'

export default {
  name: 'DrawerSlot',
  computed: {
    openFlag() {
      return this.$store.getters[drawerGetters.showFlag]
    },
  },
  methods: {
    changeDrawerFlag(val) {
      if (val === null) {
        return
      }
      this.$store.dispatch(drawerActions.SHOW_DRAWER, { flag: val })
    },
  },
}
</script>

<style scoped></style>
